export default __webpack_public_path__ + "media/zurb/img/icons/favicon/favicon-32x32-dbc30baf14d17132bb3f4f1e34b117df.png";